import { IsNotEmpty, IsOptional, IsString, IsUUID } from 'class-validator'

import { ParentModel } from '@blueprint/frontend-basics'

export class ShopDto extends ParentModel {
  @IsUUID()
  @IsNotEmpty()
  id!: string

  @IsString()
  @IsNotEmpty()
  name!: string

  @IsString()
  @IsOptional()
  creationDate?: string
}
